import { render, staticRenderFns } from "./PopupComponent.vue?vue&type=template&id=4b026bf8&scoped=true&"
import script from "./PopupComponent.vue?vue&type=script&lang=js&"
export * from "./PopupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b026bf8",
  null
  
)

export default component.exports